import {apiFetch} from '@livingdata/playground-core-front'

// The routes Geoprompt adds to the shared API, and the Better Auth routes the
// app drives itself. The shared routes are called through core-front's own
// module.

const CHARTER_ACKNOWLEDGEMENT = 'api/charter/acknowledgement'
const SESSION = 'api/auth/get-session'
const SIGN_IN = 'api/auth/sign-in/oauth2'
const SIGN_OUT = 'api/auth/sign-out'

/** When the connected account read the charter, `undefined` if it never did. */
export async function fetchCharterReadAt(): Promise<string | undefined> {
  // The route answers `null` for a charter never read. Callers get `undefined`,
  // the one way this codebase says "no value".
  // eslint-disable-next-line @typescript-eslint/no-restricted-types
  const {readAt} = await apiFetch(CHARTER_ACKNOWLEDGEMENT).json<{readAt: string | null}>()

  return readAt ?? undefined
}

/** Records a reading of the charter. The date is the server's, so nothing is sent. */
export async function recordCharterRead(): Promise<void> {
  await apiFetch(CHARTER_ACKNOWLEDGEMENT, {method: 'PUT'})
}

export type SessionUser = {
  id: string;
  email?: string;
  name?: string;
}

/** The signed-in user, `undefined` when nobody is. */
export async function fetchSessionUser(): Promise<SessionUser | undefined> {
  // Better Auth answers 200 rather than 401 when nobody is signed in, which is
  // why this is the route the app asks first. The body is then `null`, not an
  // object without a user, so it cannot be destructured.
  // eslint-disable-next-line @typescript-eslint/no-restricted-types
  const session = await apiFetch(SESSION).json<{user?: SessionUser} | null>()

  return session?.user
}

/** Where the identity provider expects the browser to go next. */
export async function startOAuthSignIn(returnTo: string): Promise<string | undefined> {
  const {url} = await apiFetch(SIGN_IN, {
    method: 'post',
    json: {
      providerId: 'isogeo',
      callbackURL: returnTo,
      errorCallbackURL: returnTo
    }
  }).json<{url?: string}>()

  return url
}

export async function signOut(): Promise<void> {
  await apiFetch(SIGN_OUT, {method: 'post'})
}
